import { Stack } from "@altimateai/lego";
import { InsightStatus } from "../constants";

const OpportunityStatusTooltip = ({ assignedStatus }: { assignedStatus: string }) => {
  return (
    <Stack tag="ul" direction="column" className="al-pl-4 al-max-w-[300px]">
      {assignedStatus === InsightStatus.ACTIVE ? (
        <li>
          [Active] New optimization opportunity identified. Review and decide whether to implement
          or dismiss.
        </li>
      ) : null}
      {assignedStatus === InsightStatus.IMPLEMENTED ? (
        <li>[Implemented] This opportunity has been implemented.</li>
      ) : null}
      {assignedStatus === InsightStatus.DISMISSED ? (
        <li>[Dismissed] This opportunity has been dismissed and cannot be implemented.</li>
      ) : null}
    </Stack>
  );
};

export default OpportunityStatusTooltip;
